import React from 'react';
import { Link } from 'react-router-dom';
import './back-link.css';

const BackLink = ({ href }) => (
  <Link className="back-link" to={href}>
    Back
  </Link>
);

export default BackLink;



// WEBPACK FOOTER //
// ./src/components/common/back-link/index.jsx